import { Button, Stack, Step, StepLabel, Stepper } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Recap from '../Components/Recap'
import SearchBySerialNumber from '../Components/SearchBySerialNumber'
import SelectTracker from '../Components/SelectTracker'
import TestGateway from '../Components/TestGateway'


const TestGatewaySteps = () => {
  const [currentStep, setCurrentStep] = useState(0)
  const [enableButton, setEnableButton] = useState(false)
  const [gatewayData, setGatewayData] = useState(null)
  const [trackerData, setTrackerData] = useState(null)
  const [result, setResult] = useState(null)
  const navigate = useNavigate()

  const showCurrentStep = () => {
    const steps = [
      <SearchBySerialNumber setEnableButton={setEnableButton} data={gatewayData} setData={setGatewayData} key={0} />,
      <SelectTracker data={gatewayData} tracker={trackerData} setTracker={setTrackerData} key={1} />,
      <TestGateway tracker={trackerData} gateway={gatewayData} setResult={setResult} key={2} />,
      <Recap result={result} gateway={gatewayData} key={3} />
    ]

    return steps[currentStep]
  }

  const handleNextStep = () => {
    if (currentStep >= 3) {
      navigate('/select-test')
    }
    if (result == null) {
      setEnableButton(false)
    }
    setCurrentStep((prev) => prev + 1)
  }

  useEffect(() => {
    if (trackerData != null) {
      setEnableButton(true)
    }
  }, [trackerData])

  useEffect(() => {
    if (result != null) {
      setEnableButton(true)
    }
  }, [result])

  return (
    <Stack
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginTop={5}
      width="100%"
      minHeight={'80vh'}>
      <Stepper activeStep={currentStep} alternativeLabel>
        <Step key="insertSerialNumber">
          <StepLabel>Seleziona Gateway</StepLabel>
        </Step>
        <Step key="selectTracker">
          <StepLabel>Seleziona Tracker</StepLabel>
        </Step>
      </Stepper>

      {showCurrentStep()}

      <Button
        id="add-rule-dialog-button-save"
        variant="contained"
        disabled={!enableButton}
        sx={{ mt: 'auto', width: '90%' }}
        onClick={handleNextStep}
      >
        {currentStep < 3 ? 'Avanti' : 'Fine'}
      </Button>
    </Stack>
  )
}

export default TestGatewaySteps
